import * as React from 'react'
import {graphql, Link} from "gatsby";
import { Layout } from '../components/Layout'
import { SliceZone } from '../components/SliceZone'
import {useTranslation} from 'gatsby-plugin-react-i18next';
import slugify from "react-slugify";


const Level2 = ({ data, pageContext }) => {
	const {t} = useTranslation();

	if (!data) return null;

	const page = data.prismicLevel2 || {};
	const { lang, type, url } = page || {}

	const relatedPages = Array.isArray(page.data.related_pages) ? page.data.related_pages.filter(page => page.title1.text.length > 0) : [];
	const title = page.data.title.text;
	const desc = page.data.meta_description;

	const alternateLanguages = page.alternate_languages || []
	const activeDoc = {
		lang,
		type,
		url,
		alternateLanguages,
		title,
		desc
	}

	let colClass = '';
	switch (page.data.related_pages.length) {
		case 2:
			colClass = 'o-2-col';
			break;
		case 3:
			colClass = 'o-3-col';
			break;
		default:
			colClass = '';
	}
	let tocItems = [];
	for (const value of page.data.body) {
		if (value.primary.title1 && value.primary.title1.text) {
			tocItems.push(value.primary.title1.text);
		}
	}

	return (
		<Layout activeDocMeta={activeDoc} themes={data.allPrismicTheme}>
			<div className="o-wrapper c-intro">
				<div className="o-1-col">
					<Link className="c-intro-home-link o-routing-link -back-on-hover" to={page.data.parent.url}>{page.data.parent?.document?.data?.title?.text}</Link>
					<h1 className="c-intro-block__title">{page.data.title.text}</h1>
					<div className="o-intro-text" dangerouslySetInnerHTML={{ __html: page.data.intro.html }} />
				</div>
			</div>

			{(data.allPrismicLevel3Step.nodes && data.allPrismicLevel3Step.nodes.length > 0) &&
				<div className="o-wrapper">
					<ol className="o-3-col c-step-block">
						{data.allPrismicLevel3Step.nodes.map((value) => {
							return <li className="c-step-block__item" key={value.id}>
								<div>
									<h3><Link to={value.url}>{value.data.title.text}</Link></h3>
									<div dangerouslySetInnerHTML={{ __html: value.data.abstract.html }} />
								</div>
							</li>
						})}
					</ol>
				</div>
			}
			<div className={`o-wrapper o-2-col -sidearea`}>
				<div>
					<SliceZone slices={page.data.body}/>

					{(data.allPrismicLevel3Faq.nodes && data.allPrismicLevel3Faq.nodes.length > 0) &&
						<div className="c-content-block">
							<h3>{page.data.related_faq_title.text ? page.data.related_faq_title.text : t('FAQ')}</h3>
							<ul>
								{data.allPrismicLevel3Faq.nodes.map((value) => {
									return <li key={value.id}>
										<Link to={value.url}>{value.data.title.text}</Link>
									</li>
								})}
							</ul>
						</div>
					}

				</div>
				<div className="is-sidearea">
					<div className="c-sidearea">
				{ (page.data.show_table_of_contents && tocItems.length > 0) &&

							<div className="toc-block">
                <h3>{t('toc')}</h3>
                <ul>
                  {tocItems.map((value, index) => { return <li key={'toc-' + index}><a href={'#' + slugify(value)}>{value}</a></li>})}
                </ul>
              </div>
				}
						{/*<div className="share-block">
							<h3>Deel dit artikel</h3>
							<ul className="u-reset-list c-footer__contact__social">
								<li className="c-footer__contact__social__item">
									<a href="http://www.facebook.com/vdab.be" className="c-round-btn -primary icon-social-facebook" aria-label="Facebook"><span>Facebook</span></a>
								</li>
								<li className="c-footer__contact__social__item">
									<a href="http://twitter.com/vdab_be" className="c-round-btn -primary icon-social-twitter" aria-label="Twitter"><span>Twitter</span></a>
								</li>
								<li className="c-footer__contact__social__item">
									<a href="http://www.linkedin.com/company/10197" className="c-round-btn -primary icon-social-linkedin" aria-label="LinkedIn"><span>Linkedin</span></a>
								</li>
								<li className="c-footer__contact__social__item">
									<a href="https://www.youtube.com/channel/UCiQbsoXoboEGfFGwiaPKBFg/featured" className="c-round-btn -primary icon-youtube"><span>Youtube</span></a>
								</li>
								<li className="c-footer__contact__social__item">
									<a href="https://www.instagram.com/vdab_be" className="c-round-btn -primary icon-mdi-instagram" aria-label="Instagram"><span>Instagram</span></a>
								</li>
							</ul>
						</div>*/}
					</div>
				</div>
			</div>
			{relatedPages.length > 0 &&
			<div className="o-wrapper related related-pages u-bg-grey-100">
				{page.data.related_title.text && <h2>{page.data.related_title.text}</h2>}
				<div className={colClass}>
					{relatedPages.map((value, index) => { return <div className="related-page" key={index}>
						{value.title1.text && <h3>{value.title1.text}</h3>}
						<div dangerouslySetInnerHTML={{ __html: value.text.html}} />
					</div>})}
				</div>
			</div>
			}
		</Layout>
	)
}

export default Level2;

export const query = graphql`
query MyQuery($lang: String, $id: String, $prismicId: ID!, $locale: String) {
  locales: allLocale(filter: {language: {eq: $locale}}) {
    edges {
      node {
        ns
        data
        language
      }
    }
  }
	allPrismicLevel3Step(
		filter: {data: {parent: {id: {eq: $prismicId}}}, lang: {eq: $lang}}
		sort: {fields: data___weight, order: ASC}
		) {
		nodes {
		  data {
		    title {
		      text
		    }
			abstract {
				html
			}
		  }
		  url
		  id
		  prismicId
		}
	}
	allPrismicLevel3Faq(
		filter: {data: {parent: {id: {eq: $prismicId}}}, lang: {eq: $lang}},
		sort: {fields: data___weight, order: ASC}
	) {
		nodes {
		  data {
		    title {
		      text
		    }
		  }
		  url
		  id
		  prismicId
		}
	}
  prismicLevel2(id: {eq: $id}, lang: {eq: $lang}) {
    data {
      body {
        ... on PrismicLevel2DataBodyImage {
          id
          primary {
            image {
              alt
              url
              localFile {
				  childImageSharp {
					gatsbyImageData(width: 1600, layout: CONSTRAINED)                   
				  }              
                publicURL
              }
            }
          }
          slice_type
        }      
        ... on PrismicLevel2DataBodyDownload {
          id
          slice_type
          primary {
            file {
                url
                size
				localFile {
					extension
					publicURL
					size
				}
            }
            label
          }
        }
        ... on PrismicLevel2DataBodyQuote {
          id
          primary {
            author
            image {
              alt
              url
			  localFile {
				publicURL
			  }              
            }
            quote {
              html
            }
          }
          slice_type
        }
        ... on PrismicLevel2DataBodyTextblock {
          id
          primary {
            text {
              html
            }
            title1 {
              text
            }
          }
          slice_type
        }
      }
      meta_description
      intro {
        html
      }
      parent {
        url
        document {
          ... on PrismicTheme {
            id
            data {
              title {
                text
              }
            }
          }
        }
      }
      related_pages {
        text {
          html
        }
        title1 {
          text
        }
      }
      related_title {
        text
      }
      related_faq_title {
        text
      }      
      show_table_of_contents
      title {
        text
      }
    }
    url
      alternate_languages {
        document {
          ... on PrismicLevel2 {
            url
          }
          ... on PrismicTheme {
            url
          }
          ... on PrismicHome {
            url
          }
          ... on PrismicLevel3Faq {
            url
          }
          ... on PrismicLevel3Step {
            url
          }
          ... on PrismicDisclaimer {
            url
          }
          ... on PrismicPrivacy {
            url
          }
        }
        lang
      }
    lang
  }
  allPrismicTheme(
    filter: {lang: {eq: $lang}}
    sort: {fields: data___weight, order: ASC}
  ) {
    nodes {
      id
      data {
        title {
          text
        }
      }
      prismicId
      url
    }
  }
}

`;
